import { TemplateData, TemplateParams } from '.';

const calendarEventRegistrationQueuedForOthers = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventRegistrationEmailForOthersQueued}
      </p>
      <p>
        {{userData}}
      </p>`,
    contentAfterButton: messages.emailSignatureText,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventRegistrationEmailForOthersSubject}`
  },
  placeholders: {
    eventTime: {
      label: messages.calendarEventDateAndTime,
      example: '27.3.2024 08:00 - 10:00'
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    userData: {
      label: messages.profileUserData
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventRegistrationQueuedForOthers
});

export default calendarEventRegistrationQueuedForOthers;
